export const messagesAdmMarketingPlan = {
    pt: {
        message:{
            addPlan: "Adicionar Plano",
            editPlan: "Editar Plano",
            emailAmount: "Quantidade de E-mails",
            link: "Vincular",
            managePlans: "Gerenciar Planos",
            noPlansRegistered: "Nenhum plano cadastrado",
            smsAmount: "Quantidade de SMSs",
            whatsAppAmount: "Quantidade de WhatsApp"

        }
    },
    es: {
        message:{
            addPlan:"Agregar plan",
            editPlan:"Editar plan",
            emailAmount:"Cantidad de correos electrónicos",
            link:"Enlace",
            managePlans:"Administrar planes",
            noPlansRegistered:"No hay plan registrado",
            smsAmount:"Cantidad de SMS",
            whatsAppAmount: "Cantidad de WhatsApp"
        }
    },
    en: {
        message:{
            addPlan: "Add Plan",
            editPlan: "Edit Plan",
            emailAmount: "E-mail Amount",
            link: "Link",
            managePlans: "Manage Plans",
            noPlansRegistered: "No plans registered",
            smsAmount: "SMS Amount",
            whatsAppAmount: "WhatsApp Amount"

        }
    }
}
